/* eslint-disable max-len */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import makeBodyText from '../../utils/makeText';
import getDaysInCurrentMonth from '../../utils/getDaysInCurrentMonth';
import styles from './index.module.scss';
import { DAYS, EXTRA_VALUES } from './constants';
import { ENTER_KEYDOWN, SPACE_KEYDOWN } from '../../constants/keydown';
const Calendar = (props) => {
    const { withParent, withoutShadow, isGray, isOpen, selectedValue, setSelectedValue, withLabel, isFirstSelect, isSecondSelect } = props;
    const getCurrentDays = useMemo(() => Array.from(Array(getDaysInCurrentMonth()).keys()).map((key) => DAYS[key]), []);
    const _handleSelect = (e) => setSelectedValue(e.target.dataset.value);
    const _handleKeyDown = (e) => {
        if ([ENTER_KEYDOWN, SPACE_KEYDOWN].includes(e.keyCode)) {
            setSelectedValue(e.target.dataset.value);
        }
    };
    const _isActive = (value) => {
        return selectedValue.some((selected) => Number(selected) === Number(value));
    };
    const _renderCalendarButton = ({ value }) => {
        const isActiveButton = _isActive(value);
        const isFirstSelected = Number(selectedValue[0]) === Number(value) && isFirstSelect;
        const isSecondSelected = Number(selectedValue[1]) === Number(value) && isSecondSelect;
        const classes = classnames({
            [styles.dayBtn]: true,
            [styles.selected]: isActiveButton,
            [styles.ghost]: isFirstSelected || isSecondSelected
        });
        return (React.createElement("button", { key: value, type: 'button', id: String(value), "data-value": value, className: classes, onKeyDown: _handleKeyDown, onMouseDown: isActiveButton ? undefined : _handleSelect }, value === -1 ? 'Last Day' : value));
    };
    if (!isOpen) {
        return null;
    }
    const classNames = classnames({
        [styles.calendarWrap]: true,
        [styles.withParent]: withParent,
        [styles.grayBcg]: isGray,
        [styles.withoutShadow]: withoutShadow,
        [styles.isFullWidth]: true
    });
    const getPostfix = (i) => {
        let postfix = 'th';
        if ([1, 21, 31].includes(i)) {
            postfix = 'st';
        }
        else if ([2, 22].includes(i)) {
            postfix = 'nd';
        }
        else if ([3, 23].includes(i)) {
            postfix = 'rd';
        }
        return postfix;
    };
    const isLastDay = (value) => value === EXTRA_VALUES[0].value;
    const _renderLabelContainer = () => {
        const firstLabel = selectedValue && selectedValue[0];
        const secondLabel = selectedValue && selectedValue[1];
        const createTitle = () => {
            if (firstLabel && !secondLabel) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("strong", null, isLastDay(firstLabel) ? EXTRA_VALUES[0].label : firstLabel),
                    getPostfix(firstLabel),
                    " of each month"));
            }
            if (!firstLabel || (!firstLabel && !secondLabel)) {
                return 'Select date';
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("strong", null, isLastDay(firstLabel) ? EXTRA_VALUES[0].label : firstLabel),
                getPostfix(firstLabel),
                " and ",
                React.createElement("strong", null, isLastDay(secondLabel) ? EXTRA_VALUES[0].label : secondLabel),
                getPostfix(secondLabel),
                " of each month"));
        };
        return (React.createElement("div", { className: `${styles.labelWrap} ${!firstLabel && !secondLabel ? styles.placeholderWrap : ''}` },
            React.createElement("span", { className: makeBodyText('L') }, createTitle())));
    };
    return (React.createElement("div", { className: classNames },
        withLabel && _renderLabelContainer(),
        React.createElement("div", { className: styles.calendar }, [...getCurrentDays, ...EXTRA_VALUES].map(_renderCalendarButton))));
};
export default Calendar;
